import { Paper, Text, Group } from '@mantine/core'

export function ProfileHeader({ programName, completedAt, duration }) {
  return (
    <Paper p="lg" className="glass" style={{ borderColor: 'rgba(0, 229, 255, 0.2)', textAlign: 'center' }}>
      <Text size="xs" c="dimmed" ff="Orbitron, sans-serif" fw={600} tt="uppercase" lts={2} mb={4}>
        Projected Learning Profile
      </Text>
      <Text size="xl" fw={700} ff="Orbitron, sans-serif" c="cyan.3" className="glow-text-cyan">
        {programName}
      </Text>
      <Group gap="md" justify="center" mt={6}>
        {completedAt && (
          <Text size="xs" c="dimmed">
            Demo completed {new Date(completedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </Text>
        )}
        {duration && (
          <Text size="xs" c="dimmed">{duration} min session</Text>
        )}
      </Group>
    </Paper>
  )
}
